import useCreateMetaRuleGq from './mutations/contentPlan/metaRules/useCreateMetaRuleGq';
import useDeleteMetaRuleGq from './mutations/contentPlan/metaRules/useDeleteMetaRuleGq';
import useUpdateMetaRuleGq from './mutations/contentPlan/metaRules/useUpdateMetaRuleGq';
import useAddTaskKeywordsGq from './mutations/contentPlan/useAddTaskKeywordsGq';
import useApplyChatGptOnContentTasksGq from './mutations/contentPlan/useApplyChatGptOnContentTasksGq';
import useApproveContentTaskGq from './mutations/contentPlan/useApproveContentTaskGq';
import useApproveContentTasksGq from './mutations/contentPlan/useApproveContentTasksGq';
import useArchiveTaskKeywordsGq from './mutations/contentPlan/useArchiveTaskKeywordsGq';
import useChangeKeywordOrderGq from './mutations/contentPlan/useChangeKeywordOrderGq';
import useDownloadContentPlanGq from './mutations/contentPlan/useDownloadContentPlanGq';
import useInitiateCrawlBasedPlanGq from './mutations/contentPlan/useInitiateCrawlBasedPlanGq';
import useInitiateRerunGq from './mutations/contentPlan/useInitiateRerunGq';
import useInitiateTagBasedPlanGq from './mutations/contentPlan/useInitiateTagBasedPlanGq';
import useSplitToCreateTasksGq from './mutations/contentPlan/useSplitToCreateTasksGq';
import useSplitToSingleCreateTaskGq from './mutations/contentPlan/useSplitToSingleCreateTaskGq';
import useUpdateTaskDetailsGq from './mutations/contentPlan/useUpdateTaskDetailsGq';
import useBulkEditCompetitorsGq from './mutations/domains/useBulkEditCompetitorsGq';
import useCheckIfDomainExistsGq from './mutations/domains/useCheckIfDomainExistsGq';
import useCreateDomainsGq from './mutations/domains/useCreateDomainsGq';
import useDeleteDomainGq from './mutations/domains/useDeleteDomainGq';
import useUpdateDomainGq from './mutations/domains/useUpdateDomainGq';
import useCreateGoogleAdsRequestGq from './mutations/googleAds/useCreateGoogleAdsRequestGq';
import useDeleteGoogleAdsRequestGq from './mutations/googleAds/useDeleteGoogleAdsRequestGq';
import useUpdateGoogleAdsRequestGq from './mutations/googleAds/useUpdateGoogleAdsRequestGq';
import useCopyComboRequestGq from './mutations/googleAdsCombo/useCopyComboRequestGq';
import useCreateComboListGq from './mutations/googleAdsCombo/useCreateComboRequestGq';
import useDeleteComboRequestGq from './mutations/googleAdsCombo/useDeleteComboRequestGq';
import useProcessComboRequestGq from './mutations/googleAdsCombo/useProcessComboRequestGq';
import useUpdateComboListGq from './mutations/googleAdsCombo/useUpdateComboRequestGq';
import useUpdateProjectRankLangLocGq from './mutations/projects/updateRankLangLocGq';
import useAddQuickSearchToProjectGq from './mutations/projects/useAddQuickSearchToProjectGq';
import useArchiveKeywordGq from './mutations/projects/useArchiveKeywordGq';
import useArchiveKeywordsGq from './mutations/projects/useArchiveKeywordsGq';
import useArchiveProjectGq from './mutations/projects/useArchiveProjectGq';
import useCopyKeywordsGq from './mutations/projects/useCopyProjectGq';
import useCreateAnalysisColorPaletteGq from './mutations/projects/useCreateAnalysisColorPaletteGq';
import useCreateAnalysisConfigurationGq from './mutations/projects/useCreateAnalysisConfigurationGq';
import useCreateProjectGq from './mutations/projects/useCreateProjectGq';
import useDeleteAnalysisColorPaletteGq from './mutations/projects/useDeleteAnalysisColorPaletteGq';
import useDeleteAnalysisConfigurationGq from './mutations/projects/useDeleteAnalysisConfigurationGq';
import useDownloadAnalysisGq from './mutations/projects/useDownloadAnalysisGq';
import useExportToExcelGq from './mutations/projects/useExportToExcelGq';
import useOrderAnalysisConfigurationsGq from './mutations/projects/useOrderAnalysisConfigurationsGq';
import useRecalculateProjectCompetitorsGq from './mutations/projects/useRecalculateProjectCompetitorsGq';
import useRenameProjectKeywordsGq from './mutations/projects/useRenameProjectKeywordsGq';
import useSelectKeywordVariantGq from './mutations/projects/useSelectKeywordVariantGq';
import useSubscribeToProjectGq from './mutations/projects/useSubscribeToProjectGq';
import useUnArchiveKeywordsGq from './mutations/projects/useUnArchiveKeywordsGq';
import useUnsubscribeFromAllProjectsGq from './mutations/projects/useUnsubscribeFromAllProjectsGq';
import useUpdateAnalysisColorPaletteGq from './mutations/projects/useUpdateAnalysisColorPaletteGq';
import useUpdateAnalysisConfigurationGq from './mutations/projects/useUpdateAnalysisConfigurationGq';
import useUpdateProjectNegativeTermsGq from './mutations/projects/useUpdateNegativeTermsGq';
import useUpdateProjectAnalysisPaletteGq from './mutations/projects/useUpdateProjectAnalysisPaletteGq';
import useUpdateProjectCurrencyGq from './mutations/projects/useUpdateProjectCurrencyGq';
import useUpdateProjectGq from './mutations/projects/useUpdateProjectGq';
import useUpdateProjectKeywordVolumesGq from './mutations/projects/useUpdateProjectKeywordVolumesGq';
import useUpdateProjectLanguageGq from './mutations/projects/useUpdateProjectLanguageGq';
import useUpdateProjectLocationGq from './mutations/projects/useUpdateProjectLocationGq';
import useUpdateProjectNameGq from './mutations/projects/useUpdateProjectNameGq';
import useUpdateProjectUseAutomaticGq from './mutations/projects/useUpdateProjectUseAutomaticGq';
import useCreateScrapeUrlsGq from './mutations/scraping/useCreateScrapeUrlsGq';
import useCollectDomainSerpGq from './mutations/serp/useCollectDomainSerp';
import useCollectSerpDataGq from './mutations/serp/useCollectSerpData';
import useTogggleSERPTrackingGq from './mutations/serp/useToggleSERPTracking';
import useAddTagsGq from './mutations/tags/useAddTagsGq';
import useBulkTagKeywordsGq from './mutations/tags/useBulkTagKeywordsGq';
import useBulkUntagKeywordsGq from './mutations/tags/useBulkUntagKeywordsGq';
import useCopyTagGroupsGq from './mutations/tags/useCopyTagGroupsGq';
import useCreateTagGroupGq from './mutations/tags/useCreateTagGroupGq';
import useDeleteConflictsGq from './mutations/tags/useDeleteConflictsGq';
import useDeleteTagGroupGq from './mutations/tags/useDeleteTagGroupGq';
import useDeleteTagsGq from './mutations/tags/useDeleteTagsGq';
import useEditTagGroupNameGq from './mutations/tags/useEditTagGroupNameGq';
import useEditTagsGq from './mutations/tags/useEditTagsGq';
import useGenerateTagsGq from './mutations/tags/useGenerateTagsGq';
import useImportTagStructureGq from './mutations/tags/useImportTagStructureGq';
import useQueueAutoTagGq from './mutations/tags/useQueueAutoTagGq';
import useSingleTagKeywordGq from './mutations/tags/useSingleTagKeywordGq';
import useSingleUntagKeywordGq from './mutations/tags/useSingleUntagKeywordGq';
import useTranslateProjectGq from './mutations/translate/useTranslateProjectGq';
import useTranslateProjectKeywordsToEnglishTriggerGq from './mutations/translate/useTranslateProjectKeywordsToEnglishTriggerGq';
import { useGetAvailableAnalysisDataGq } from './queries/analysis/useGetAvailableAnalysisDataGq';
import { useGetBestKeywordCompetitorsGq } from './queries/analysis/useGetBestKeywordCompetitorsGq';
import { useGetBestTrafficPagesGq } from './queries/analysis/useGetBestTrafficPagesGq';
import { useGetCompetitiveIntelligenceGq } from './queries/analysis/useGetCompetitiveIntelligenceGq';
import { useGetCompetitivePerformanceGq } from './queries/analysis/useGetCompetitivePerformanceGq';
import { useGetCompetitiveRankingStrategyGq } from './queries/analysis/useGetCompetitiveRankingStrategyGq';
import { useGetDomainTrafficGq } from './queries/analysis/useGetDomainTraffic';
import { useGetHBLtGq } from './queries/analysis/useGetHBLt';
import { useGetHBLtPerTagGroupGq } from './queries/analysis/useGetHBLtPerTagGroup';
import { useGetImprovedRankingGq } from './queries/analysis/useGetImprovedRankingGq';
import { useGetMarketPotentialGq } from './queries/analysis/useGetMarketPotential';
import { useGetMonthlyDemandGq } from './queries/analysis/useGetMonthlyDemandGq';
import { useGetMonthlyTrendGq } from './queries/analysis/useGetMonthlyTrendGq';
import { useGetRankIntervalsGq } from './queries/analysis/useGetRankIntervals';
import { useGetRankIntervalsPerTagGroupGq } from './queries/analysis/useGetRankIntervalsPerTagGroup';
import { useGetSearchVolumeDistributionGq } from './queries/analysis/useGetSearchVolumeDistributionGq';
import { useGetTagGroupsAndKeywordsGq } from './queries/analysis/useGetTagGroupsAndKeywordsGq';
import { useGetTagGroupsAndTagsGq } from './queries/analysis/useGetTagGroupsAndTagsGq';
import { useGetTagsAndKeywordsGq } from './queries/analysis/useGetTagsAndKeywordsGq';
import { useGetTopCombinationsByKeywordCountGq } from './queries/analysis/useGetTopCombinationsByKeywordCount';
import { useGetTopCombinationsByVolumeGq } from './queries/analysis/useGetTopCombinationsByVolume';
import { useGetTopKeywordsGq } from './queries/analysis/useGetTopKeywordsGq';
import { useGetTopTagsGq } from './queries/analysis/useGetTopTagsGq';
import { useGetTopicalCoverageGq } from './queries/analysis/useGetTopicalCoverage';
import { useGetTopicalDemandGq } from './queries/analysis/useGetTopicalDemand';
import { useGetTrafficForecastGq } from './queries/analysis/useGetTrafficForecastGq';
import { useGetConflictingTagsGq } from './queries/autoTagConflicts/useGetConflictingTagsGq';
import { useGetConflictsGq } from './queries/autoTagConflicts/useGetConflictsGq';
import { useGetTagGroupsWithConflictsGq } from './queries/autoTagConflicts/useGetTagGroupsWithConflicts';
import { useGetContentActionsGq } from './queries/contentPlan/useGetContentActionsGq';
import { useGetContentHttpStatusGq } from './queries/contentPlan/useGetContentHttpStatusGq';
import { useGetContentMissingKeywordsGq } from './queries/contentPlan/useGetContentMissingKeywordsGq';
import { useGetContentPlansGq } from './queries/contentPlan/useGetContentPlanGq';
import { useGetContentTaskKeywordsGq } from './queries/contentPlan/useGetContentTaskKeywordsGq';
import { useGetContentTasksGq } from './queries/contentPlan/useGetContentTasksGq';
import { useGetExistingUrlsGq } from './queries/contentPlan/useGetExistingUrlsGq';
import { useGetMetaRulesGq } from './queries/contentPlan/useGetMetaRulesGq';
import { useGetMetaUrlsGq } from './queries/contentPlan/useGetMetaUrlsGq';
import useGetGoogleAdwordsCategoriesGq from './queries/googleAdWords/useGetGoogleAdwordsCategoriesGq';
import useGetComboRequestGq from './queries/googleAds/useGetComboRequestGq';
import useGetComboRequestsGq from './queries/googleAds/useGetComboRequestsGq';
import useGetGoogleAdsBlockedGq from './queries/googleAds/useGetGoogleAdsBlockedGq';
import useGetGoogleAdsLanguagesGq from './queries/googleAds/useGetGoogleAdsLanguagesGq';
import useGetGoogleAdsLocationsGq from './queries/googleAds/useGetGoogleAdsLocationsGq';
import useGetGoogleAdsRequestBatchGq from './queries/googleAds/useGetGoogleAdsRequestBatchGq';
import useGetGoogleAdsRequestBatchesGq from './queries/googleAds/useGetGoogleAdsRequestBatchesGq';
import useGetGoogleAdsRequestGq from './queries/googleAds/useGetGoogleAdsRequestGq';
import useGetGoogleAdsRequestsGq from './queries/googleAds/useGetGoogleAdsRequestsGq';
import { useGetSerpProgressAnalysisGq } from './queries/progress/useGetSerpProgressAnalysisGq';
import { useGetSerpProgressDomainAnalysisGq } from './queries/progress/useGetSerpProgressDomainAnalysisGq';
import { useGetSerpProgressTagGroupAnalysisGq } from './queries/progress/useGetSerpProgressTagGroupAnalysisGq';
import { useGetAnalysisColorPalettesGq } from './queries/useGetAnalysisColorPalettesGq';
import { useGetAnalysisConfigurationsGq } from './queries/useGetAnalysisConfigurationsGq';
import { useGetAnalysisDownloadGq } from './queries/useGetAnalysisDownloadGq';
import { useGetChildProjectsGq } from './queries/useGetChildProjectsGq';
import { useGetClientNamesGq } from './queries/useGetClientNamesGq';
import { useGetCopyProgressGq } from './queries/useGetCopyProgressGq';
import { useGetCtrValuesGq } from './queries/useGetCtrValuesGq';
import { useGetDomainSerpProgressGq } from './queries/useGetDomainSerpProgressGq';
import { useGetDomainsGq } from './queries/useGetDomainsGq';
import { useGetKeywordDownloadGq } from './queries/useGetKeywordDownloadGq';
import { useGetKeywordDownloadsGq } from './queries/useGetKeywordDownloadsGq';
import { useGetKeywordSerpResultsGq } from './queries/useGetKeywordSerpResultsGq';
import { useGetKeywordsKeywordsForCopyGq } from './queries/useGetKeywordsForCopyGq';
import { useGetKeywordsGq } from './queries/useGetKeywordsGq';
import { useGetMultiProjectTagGroupsGq } from './queries/useGetMultiProjectTagGroupsGq';
import { useGetProjectDomainsGq } from './queries/useGetProjectDomainsGq';
import { useGetProjectGq } from './queries/useGetProjectGq';
import { useGetProjectStatusGq } from './queries/useGetProjectStatusGq';
import { useGetProjectsGq } from './queries/useGetProjectsGq';
import { useGetSelectedKeywordsStatsGq } from './queries/useGetSelectedKeywordsStatsGq';
import { useGetTagGroupStatsGq } from './queries/useGetTagGroupStatsGq';

export const projectsApiService = {
  queries: {
    useGetClientNames: useGetClientNamesGq,
    useGetProjectDomains: useGetProjectDomainsGq,
    useGetProject: useGetProjectGq,
    useGetProjects: useGetProjectsGq,
    useGetChildProjects: useGetChildProjectsGq,
    useGetKeywords: useGetKeywordsGq,
    useGetKeywordsForCopy: useGetKeywordsKeywordsForCopyGq,
    useGetKeywordSerpResults: useGetKeywordSerpResultsGq,
    useGetKeywordDownloads: useGetKeywordDownloadsGq,
    useGetKeywordDownload: useGetKeywordDownloadGq,
    useGetTagGroupStats: useGetTagGroupStatsGq,
    useGetMultiProjectTagGroups: useGetMultiProjectTagGroupsGq,
    useGetDomains: useGetDomainsGq,
    useGetSelectedKeywordsStats: useGetSelectedKeywordsStatsGq,
    useGetCopyProgress: useGetCopyProgressGq,
    useGetContentTasks: useGetContentTasksGq,
    useGetExistingUrls: useGetExistingUrlsGq,
    useGetMetaUrls: useGetMetaUrlsGq,
    useGetMetaRules: useGetMetaRulesGq,
    useGetContentTaskKeywords: useGetContentTaskKeywordsGq,
    useGetContentPlans: useGetContentPlansGq,
    useGetContentActions: useGetContentActionsGq,
    useGetContentHttpStatus: useGetContentHttpStatusGq,
    useGetContentMissingKeywords: useGetContentMissingKeywordsGq,
    getProjectStatus: useGetProjectStatusGq,
    useGetDomainSerpProgress: useGetDomainSerpProgressGq,
    useGetConflicts: useGetConflictsGq,
    useGetConflictingTags: useGetConflictingTagsGq,
    useGetTagGroupsWithConflicts: useGetTagGroupsWithConflictsGq,
    useGetCtrValues: useGetCtrValuesGq,
    googleAds: {
      useGetGoogleAdsBlocked: useGetGoogleAdsBlockedGq,
      useGetGoogleAdsRequest: useGetGoogleAdsRequestGq,
      useGetGoogleAdsRequests: useGetGoogleAdsRequestsGq,
      useGetGoogleAdsRequestBatches: useGetGoogleAdsRequestBatchesGq,
      useGetGoogleAdsRequestBatch: useGetGoogleAdsRequestBatchGq,
      useGetComboRequests: useGetComboRequestsGq,
      useGetComboRequest: useGetComboRequestGq,
      useGetLanguages: useGetGoogleAdsLanguagesGq,
      useGetLocations: useGetGoogleAdsLocationsGq,
    },
    googleAdWords: {
      useGetCategories: useGetGoogleAdwordsCategoriesGq,
    },
    analysis: {
      useGetAnalysisColorPalettes: useGetAnalysisColorPalettesGq,
      useGetAnalysisConfigurations: useGetAnalysisConfigurationsGq,
      useGetAvailableAnalysisData: useGetAvailableAnalysisDataGq,
      useGetTopKeywords: useGetTopKeywordsGq,
      getRankIntervalsPerTagGroup: useGetRankIntervalsPerTagGroupGq,
      getRankIntervals: useGetRankIntervalsGq,
      useGetCompetitivePerformance: useGetCompetitivePerformanceGq,
      useGetCompetitiveRankingStrategy: useGetCompetitiveRankingStrategyGq,
      useGetImprovedRanking: useGetImprovedRankingGq,
      useGetTopicalCoverage: useGetTopicalCoverageGq,
      useGetHBLt: useGetHBLtGq,
      useGetHBLtPerTagGroup: useGetHBLtPerTagGroupGq,
      useGetSearchVolumeDistribution: useGetSearchVolumeDistributionGq,
      useGetTagGroupsAndTags: useGetTagGroupsAndTagsGq,
      useGetTagGroupsAndKeywords: useGetTagGroupsAndKeywordsGq,
      useGetTagsAndKeywords: useGetTagsAndKeywordsGq,
      useGetTopCombinationsByVolume: useGetTopCombinationsByVolumeGq,
      useGetTopCombinationsByKeywordCount: useGetTopCombinationsByKeywordCountGq,
      useGetCompetitiveIntelligence: useGetCompetitiveIntelligenceGq,
      useGetTopTags: useGetTopTagsGq,
      useGetTopicalDemand: useGetTopicalDemandGq,
      useGetMonthlyDemand: useGetMonthlyDemandGq,
      useGetMonthlyTrend: useGetMonthlyTrendGq,
      useGetMarketPotential: useGetMarketPotentialGq,
      useGetBestTrafficPages: useGetBestTrafficPagesGq,
      useGetBestKeywordCompetitors: useGetBestKeywordCompetitorsGq,
      useGetDomainTraffic: useGetDomainTrafficGq,
      useGetAnalysisDownload: useGetAnalysisDownloadGq,
      useGetTrafficForecast: useGetTrafficForecastGq,
    },
    progress: {
      useGetSerpProgressAnalysis: useGetSerpProgressAnalysisGq,
      useGetSerpProgressDomainAnalysis: useGetSerpProgressDomainAnalysisGq,
      useGetSerpProgressTagGroupAnalysis: useGetSerpProgressTagGroupAnalysisGq,
    },
  },
  mutations: {
    scraping: {
      createScrapeUrls: useCreateScrapeUrlsGq,
    },
    domains: {
      useCreateDomains: useCreateDomainsGq,
      useBulkEditCompetitors: useBulkEditCompetitorsGq,
      useCheckIfDomainExists: useCheckIfDomainExistsGq,
      useUpdateDomain: useUpdateDomainGq,
      useDeleteDomain: useDeleteDomainGq,
    },
    projects: {
      useCreateProject: useCreateProjectGq,
      useRecalculateProjectCompetitors: useRecalculateProjectCompetitorsGq,
      useSubscribeToProject: useSubscribeToProjectGq,
      useUnsubscribeFromAllProjects: useUnsubscribeFromAllProjectsGq,
      useCopyProject: useCopyKeywordsGq,
      useExport: useExportToExcelGq,
      useUpdateProject: useUpdateProjectGq,
      useUpdateProjectName: useUpdateProjectNameGq,
      useUpdateProjectCurrency: useUpdateProjectCurrencyGq,
      useUpdateProjectLanguage: useUpdateProjectLanguageGq,
      useUpdateProjectLocation: useUpdateProjectLocationGq,
      useUpdateProjectNegativeTerms: useUpdateProjectNegativeTermsGq,
      useUpdateProjectRankLangLoc: useUpdateProjectRankLangLocGq,
      useUpdateProjectUseAutomatic: useUpdateProjectUseAutomaticGq,
      useArchiveProject: useArchiveProjectGq,
      useArchiveKeyword: useArchiveKeywordGq,
      useArchiveKeywords: useArchiveKeywordsGq,
      useUnarchiveKeywords: useUnArchiveKeywordsGq,
      useRenameProjectKeywords: useRenameProjectKeywordsGq,
      useDownloadAnalysis: useDownloadAnalysisGq,
      useCreateAnalysisConfiguration: useCreateAnalysisConfigurationGq,
      useUpdateAnalysisConfiguration: useUpdateAnalysisConfigurationGq,
      useDeleteAnalysisConfiguration: useDeleteAnalysisConfigurationGq,
      useOrderAnalysisConfigurations: useOrderAnalysisConfigurationsGq,
      useUpdateProjectKeywordVolumes: useUpdateProjectKeywordVolumesGq,
      useCreateAnalysisColorPalette: useCreateAnalysisColorPaletteGq,
      useUpdateAnalysisColorPalette: useUpdateAnalysisColorPaletteGq,
      useDeleteAnalysisColorPalette: useDeleteAnalysisColorPaletteGq,
      useUpdateProjectAnalysisPalette: useUpdateProjectAnalysisPaletteGq,
      useAddQuickSearchToProject: useAddQuickSearchToProjectGq,
      useSelectKeywordVariant: useSelectKeywordVariantGq,
    },
    translate: {
      useTranslateProject: useTranslateProjectGq,
      useTranslateProjectKeywordsToEnglishTrigger: useTranslateProjectKeywordsToEnglishTriggerGq,
    },
    tags: {
      useCreateTagGroup: useCreateTagGroupGq,
      useDeleteTagGroup: useDeleteTagGroupGq,
      useAddTags: useAddTagsGq,
      useImportTagStructure: useImportTagStructureGq,
      useDeleteTags: useDeleteTagsGq,
      useBulkTagKeywords: useBulkTagKeywordsGq,
      useBulkUntagKeywords: useBulkUntagKeywordsGq,
      useSingleApplyTag: useSingleTagKeywordGq,
      useSingleUntagKeyword: useSingleUntagKeywordGq,
      useQueueAutoTagGq: useQueueAutoTagGq,
      useEditTagGroupName: useEditTagGroupNameGq,
      useEditTags: useEditTagsGq,
      useDeleteConflicts: useDeleteConflictsGq,
      useCopyTagGroups: useCopyTagGroupsGq,
      useGenerateTags: useGenerateTagsGq,
    },
    serp: {
      useCollectSerpData: useCollectSerpDataGq,
      useCollectDomainSerp: useCollectDomainSerpGq,
      useToggleSERPTracking: useTogggleSERPTrackingGq,
    },
    googleAds: {
      useCreateGoogleAdsRequest: useCreateGoogleAdsRequestGq,
      useUpdateGoogleAdsRequest: useUpdateGoogleAdsRequestGq,
      useDeleteGoogleAdsRequest: useDeleteGoogleAdsRequestGq,
    },
    googleAdsCombo: {
      useCreateComboList: useCreateComboListGq,
      useUpdateComboList: useUpdateComboListGq,
      useCopyComboRequest: useCopyComboRequestGq,
      useDeleteComboList: useDeleteComboRequestGq,
      useProcessComboList: useProcessComboRequestGq,
    },
    contentPlan: {
      useApplyChatGptOnContentTasks: useApplyChatGptOnContentTasksGq,
      useInitiateRunFromScrape: useInitiateCrawlBasedPlanGq,
      useInitiateTagBasedPlan: useInitiateTagBasedPlanGq,
      useDownloadContentPlan: useDownloadContentPlanGq,
      useSplitToCreateTasks: useSplitToCreateTasksGq,
      useSplitToSingleCreateTask: useSplitToSingleCreateTaskGq,
      useArchiveTaskKeywords: useArchiveTaskKeywordsGq,
      useAddTaskKeywords: useAddTaskKeywordsGq,
      useChangeKeywordOrder: useChangeKeywordOrderGq,
      useApproveContentTask: useApproveContentTaskGq,
      useApproveContentTasks: useApproveContentTasksGq,
      useUpdateTaskDetails: useUpdateTaskDetailsGq,
      useInitiateRerun: useInitiateRerunGq,
      useCreateMetaRule: useCreateMetaRuleGq,
      useUpdateMetaRule: useUpdateMetaRuleGq,
      useDeleteMetaRule: useDeleteMetaRuleGq,
    },
  },
};
